module.exports = __webpack_public_path__ + "img/monitorbox22.732b59e1.jpg";